import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Locks", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { class: "mb-4 flex justify-end flex-col sm:flex-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "New lock", -1)
const _hoisted_6 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_8 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg sm:max-w-full sm:mx-4" }
const _hoisted_9 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "overflow-x-auto" }
const _hoisted_14 = { class: "align-middle inline-block min-w-full" }
const _hoisted_15 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_16 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Violation "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-center text-xs font-medium text-gray-500 border-r"
    }, " Author "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-center text-xs font-medium text-gray-500"
    }, " Time ")
  ])
], -1)
const _hoisted_18 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_19 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_20 = { class: "px-3 py-2 border-r text-sm text-center" }
const _hoisted_21 = { class: "px-3 py-2 text-sm text-center" }
const _hoisted_22 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_lock_table = _resolveComponent("lock-table")!
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_app_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNewLockClick())),
            type: "green",
            class: _normalizeClass(['w-full sm:w-auto'])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_lock_table, {
          ref: "lockTable",
          onOpenViolationModal: _ctx.openViolationModal
        }, null, 8, ["onOpenViolationModal"])
      ])
    ]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.modalIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_7,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_DialogTitle, {
                        as: "h2",
                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, "Lock: " + _toDisplayString(_ctx.modalLock.lockReason.name), 1),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDate(_ctx.modalLock.dateFrom)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.modalLock.dateTo)), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("table", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("tbody", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalLock.violations, (violation) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: violation.id,
                                      class: "hover:bg-gray-50"
                                    }, [
                                      _createElementVNode("td", _hoisted_19, [
                                        _createElementVNode("span", null, _toDisplayString(violation.violation), 1)
                                      ]),
                                      _createElementVNode("td", _hoisted_20, [
                                        _createElementVNode("span", null, _toDisplayString(violation.person.name) + " " + _toDisplayString(violation.person.surname), 1)
                                      ]),
                                      _createElementVNode("td", _hoisted_21, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDatetime(violation.time_created)), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_app_button, {
                        onClick: _ctx.closeModal,
                        type: "gray",
                        class: _normalizeClass(['w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}